import { IDeleteContasReceberParcialUseCase } from "../../../presentation/useCases/delete/delete_contas_receber_parcial_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * DeleteContasReceberParcialUseCase
 */

export class DeleteContasReceberParcialUseCase implements IDeleteContasReceberParcialUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deleteContasReceberParcial(id: number): Promise<void> {
    await this.repository.deleteContasReceberParcial(id);

  }

}
